var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 10,
    height: 9,
    rx: 1,
    transform: "translate(4 9)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "complete_icon",
    transform: "translate(-298 -1200)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 26,
    height: 26,
    transform: "translate(298 1200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    "data-name": "Group 1839",
    transform: "translate(298 1200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2625",
    "data-name": "Path 2625",
    transform: "translate(1 1)",
    fill: "#1fa549"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 23.5 C 8.928239822387695 23.5 6.040329933166504 22.30378913879395 3.868269920349121 20.13172912597656 C 1.696210026741028 17.95966911315918 0.5 15.0717601776123 0.5 12 C 0.5 8.928239822387695 1.696210026741028 6.040329933166504 3.868269920349121 3.868269920349121 C 6.040329933166504 1.696210026741028 8.928239822387695 0.5 12 0.5 C 15.0717601776123 0.5 17.95966911315918 1.696210026741028 20.13172912597656 3.868269920349121 C 22.30378913879395 6.040329933166504 23.5 8.928239822387695 23.5 12 C 23.5 15.0717601776123 22.30378913879395 17.95966911315918 20.13172912597656 20.13172912597656 C 17.95966911315918 22.30378913879395 15.0717601776123 23.5 12 23.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12 1 C 9.061790466308594 1 6.299449920654297 2.144199371337891 4.221820831298828 4.221820831298828 C 2.144199371337891 6.299449920654297 1 9.061790466308594 1 12 C 1 14.93820953369141 2.144199371337891 17.7005500793457 4.221820831298828 19.77817916870117 C 6.299449920654297 21.85580062866211 9.061790466308594 23 12 23 C 14.93820953369141 23 17.7005500793457 21.85580062866211 19.77817916870117 19.77817916870117 C 21.85580062866211 17.7005500793457 23 14.93820953369141 23 12 C 23 9.061790466308594 21.85580062866211 6.299449920654297 19.77817916870117 4.221820831298828 C 17.7005500793457 2.144199371337891 14.93820953369141 1 12 1 M 12 0 C 18.62742042541504 0 24 5.372579574584961 24 12 C 24 18.62742042541504 18.62742042541504 24 12 24 C 5.372579574584961 24 0 18.62742042541504 0 12 C 0 5.372579574584961 5.372579574584961 0 12 0 Z",
    stroke: "none",
    fill: "#1b843c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    "data-name": "Group 1838",
    transform: "translate(1 0.521)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    "data-name": "Group 1837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M12751-11968.5h-10a.5.5,0,0,1-.5-.5v-13a.5.5,0,0,1,.5-.5h9.034l1.467,2.222V-11969A.5.5,0,0,1,12751-11968.5Z",
    transform: "translate(-12733 11988)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M-12722.947,11988.58l-.869,2.445,2.212-.162Z",
    transform: "translate(12313.836 -12419.775) rotate(-2)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    "data-name": "Group 1836"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 3,
    transform: "translate(14.5 9.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 3,
    transform: "translate(14.5 11.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 3,
    transform: "translate(14.5 13.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 3,
    transform: "translate(14.5 15.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-volume-2",
    "data-name": "Icon feather-volume-2",
    transform: "translate(11.656 9.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M4.209,7.5l-.672.537H3v.806h.537l.672.537Z",
    transform: "translate(0 -0.096)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M23.784,7.395a1.343,1.343,0,0,1,0,1.9M23.31,7.869a.672.672,0,0,1,0,.95",
    transform: "translate(-18.491 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    "data-name": "Group 1835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    transform: "translate(4 8)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 9.5,
    height: 8.5,
    rx: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    transform: "translate(6 10)",
    fill: "#c8c8c8",
    stroke: "#fff",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 0.85,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    transform: "translate(0 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M-12735.016,11996.949a4.487,4.487,0,0,1,2.411-1.088c1.178,0,1.51.977,2.928,1.37a7.5,7.5,0,0,0,2.745.2l1.368-.2v2.312h-9.452Z",
    transform: "translate(12739.289 -11981.889)",
    fill: "#c8c8c8",
    stroke: "#fff",
    strokeWidth: 0.4
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M5.129,15.616.221,10.709a.755.755,0,0,1,0-1.068L1.289,8.573a.755.755,0,0,1,1.068,0l3.306,3.306L12.743,4.8a.755.755,0,0,1,1.068,0l1.068,1.068a.755.755,0,0,1,0,1.068L6.2,15.616A.755.755,0,0,1,5.129,15.616Z",
    transform: "translate(5.45 2.792)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete_icon.766e5e6ff9ca7d137917b921dbf83dd4.svg";
export { ForwardRef as ReactComponent };